module.exports = __webpack_public_path__ + "static/media/generalelectric.afbaec8c.png";